import { Button, Stack } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ReminderFormSnoozeDate } from "web_myplann/Reminders/Components/ReminderFormSnoozeDate";
import { useReminderSnoozeForm } from "web_myplann/Reminders/Hooks/useReminderSnoozeForm";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";
import { getSnoozeBaseDate } from "web_myplann/Reminders/Utils/snoozeDates";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";
import { useSheetBottomSpacing } from "web_myplann/Shared/Hooks/useSheetBottomSpacing";

type Props = {
	reminder: Reminder;
	open: boolean;
	onClose: () => void;
};

export const ReminderSnoozeDrawer = ({ reminder, open, onClose }: Props) => {
	const { t } = useResource();
	const bottomSpacing = useSheetBottomSpacing(2);

	const { form, submit, isSubmitting } = useReminderSnoozeForm({
		reminder,
		onSuccess: onClose,
	});
	const { control, formState } = form;

	const minSnoozeDate = getSnoozeBaseDate(reminder.date);

	return (
		<MyPlannDrawer
			open={open}
			onClose={onClose}
			closeButton
			title={t(Resources.Reminders.Snooze.title)}
		>
			<Stack px={2} pb={bottomSpacing} gap={2}>
				<ReminderFormSnoozeDate
					control={control}
					minSnoozeDate={minSnoozeDate}
				/>

				<Button onClick={submit} disabled={!formState.isValid || isSubmitting}>
					{t(Resources.Reminders.Snooze.confirm)}
				</Button>
			</Stack>
		</MyPlannDrawer>
	);
};
